import { type EntityMetadata, type SeoFormValues } from './ContentItemEditor.types';

// The SEO record the metadata request sends, or null for a content item that has none.
export function entityMetadataFromForm(
    values: SeoFormValues,
    record: { entity_metadata?: EntityMetadata | null },
): EntityMetadata | null {
    const entityMetadata = record.entity_metadata;
    if (!entityMetadata) return null;

    return {
        ...entityMetadata,
        title: values.seo_title,
        description: values.seo_description,
        canonical_url: values.seo_canonical_url,
        tweet_template: values.tweet_template,
    };
}
